<!--
 * @Description: 
 * @Date: 2020-07-27 11:25:02
-->
<template>
  <div class="swiper">
    <van-swipe :autoplay="3500" loop :touchable="true" :stop-propagation="false">
      <van-swipe-item v-for="(image, index) in bannerImg" :key="index" @click="toLocation(image)">
        <img class="banner-img" v-lazy="image.picUrl">
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    bannerImg: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  data () {
    return {};
  },
  methods: {
    toLocation (data) {
      const obj = {
        1: 'liveDetail',
        2: 'courseDetail',
        3: 'infoDetail',
        4: 'caseDetail',
        5: 'surveyDetail'
      };
      if (data.linkType) {
        this.$router.push({
          name: obj[data.linkType],
          params: {
            id: data.linkId,
          },
          query: this.$route.query
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
.swiper {
  width: 100%;
  height: 5.31rem;
}
.banner-img {
  width: 100%;
  height: 5.31rem;
}
</style>
